import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MainCampaignActions } from '../../main-campaign.actions';
import { NavigationExtras, Router } from '@angular/router';
import { mainCampaignServices } from '../../main-campaign.services';
import { GlobalService } from '../../../global.service';

import { from } from 'rxjs';
import { delay, pluck } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';


@Component({
    selector: 'app-change-plan-step-4',
    templateUrl: './change-plan-step-4.component.html',
    styleUrls: ['./change-plan-step-4.component.scss']
})
export class ChangePlanStep4Component implements OnInit {

    form: FormGroup;
    broad_plan: any;
    step1: any;
    step2: any;
    step3: any;
    step4: any = {
        remark: ''
    };
    message: any = {
        display: false,
        success: false,
        error: false,
        message: ''
    };
    option: any;
    isSubmitLoading = false;

    subscription: any;

    isPaymentDisable = false;

    resendDelay = 60000;  // 1 min
    isResendDisabled = false;

    resendEnabled$ = new Subject();

    constructor(private store: Store<any>,
        private mainCampaignActions: MainCampaignActions,
        private fb: FormBuilder,
        private router: Router,
        private mainCampaignServices: mainCampaignServices,
        private http: HttpClient,
        private globalService: GlobalService) {

        const source = from(store);
        const example = source.pipe(pluck('mainCampaign', 'step3'));
        // store.select('mainCampaign').select('step3').subscribe(store => {
        this.subscription = example.subscribe(res => {
            this.step3 = Object.assign({}, this.step3, res);
        });



        this.form = fb.group({
            remark: ['', Validators.compose([Validators.minLength(11)])],
            tac_code: ['']
        });

        // get data
        let dataSession = this.globalService.getSession('mainApplication');
        this.step1 = dataSession.step1;
        this.step2 = dataSession.step2;
        this.step3 = Object.assign({}, dataSession.step3, this.step3);
        this.step3.referenceContactInfo.contactNumber = '60' + this.step3.referenceContactInfo.contactNumber;
        this.step3.yourDetail.contactNumber = '60' + this.step3.yourDetail.contactNumber;
        if (this.step3.transfer) {
            this.step3.transfer.contactNumber = '60' + this.step3.transfer.contactNumber;
        }
        this.option = dataSession.option;
        this.broad_plan = dataSession.step2.broad_plan;
    }

    ngOnInit() {
        this.isPaymentDisable = this.globalService.getSession('viewPlan').attributes.enable_payment === 0 && this.globalService.getSession('viewPlan').attributes.enable_credit_card === 0 ;


        console.log("Show Popup Thankyou " + this.globalService.getSession('show_popup_thankyoupage'));
        console.log("Image Popup Thankyou " + this.globalService.getSession('popup_thankyoupage'));
        console.log("URL Popup Thankyou " + this.globalService.getSession('link_popup_thankyoupage'));

        if (this.isPaymentDisable) {


            this.resendEnabled$
                .pipe(delay(this.resendDelay))
                .subscribe(() => {
                    this.isResendDisabled = false;
                });

            this.onClickRequestTAC();

            this.form.get('tac_code').setValidators(Validators.required);
        }
    }

    onClickNext() {

        var campainAttr = this.globalService.getSession('viewPlan').attributes;
        var dataURL = this.globalService.getSession('data-url');
        var voucher = this.globalService.getSession('voucher');
        this.isSubmitLoading = true;

        var questData = {
            url: dataURL,
            fullname: this.step3.yourDetail.fullName,
            nric: this.step3.yourDetail.NRIC,

            voucher: voucher,
            // // email or contact
            company: this.step3.yourDetail.companyName,
            email: this.step3.yourDetail.email,
            contact_number: this.step3.yourDetail.contactNumber,

            // card_last_digit: this.step3.yourDetail.cardLastDigit,
            nric_img: this.step3.uploadScannedIC.file,
            nric_back_img: this.step3.uploadBackScannedIC.file,
            staff_img: this.step3.uploadStaffID.file,
            remark: this.form.get('remark').value,
            tac_code: this.form.get('tac_code').value,

            billing_street: this.step3.billingAddress.streetName1,
            billing_city: this.step3.billingAddress.city,
            billing_state: this.step3.billingAddress.state,
            billing_postcode: this.step3.billingAddress.postCode,
            billing_country: this.step3.billingAddress.country.country,

            delivery_street: this.step3.deliveryAddress.streetName1,
            delivery_city: this.step3.deliveryAddress.city,
            delivery_state: this.step3.deliveryAddress.state,
            delivery_postcode: this.step3.deliveryAddress.postCode,
            delivery_country: this.step3.deliveryAddress.country.country,

            refer_fullname: this.step3.referenceContactInfo.fullName,
            refer_contact_number: this.step3.referenceContactInfo.contactNumber,

            passport_number: this.step3.yourDetail.passportNumber,
            issued_country: this.step3.yourDetail.issuedCountry,

            //broadbrand
            // broadbrand : this.globalService.getSession("broadbrand"),

            campaign_id: this.globalService.getSession('viewPlan').id,
            // // not require
            plan_id: this.step2.plan.id,

            // additional company info            
            company_name: this.step3.yourDetail.companyName,
            company_country: this.step3.deliveryAddress.country.country,
            company_city: this.step3.deliveryAddress.city,
            company_postcode: this.step3.deliveryAddress.postCode,
            company_state: this.step3.deliveryAddress.state,
            company_streetname: this.step3.deliveryAddress.streetName1,

            // additional change plan form step 1
            change_plan_for: this.step1.typeOfNumber,
            current_type_plan: this.step1.typeOfPlan,
            account_no: this.step1.acountNo,

        };
        if (this.step2.device.id) {
            questData['device_id'] = this.step2.device.id;
        }
        if (this.step2.color && this.step2.color.id) {
            questData['device_color_id'] = this.step2.color.id;
        }
        
        //add Service_id
        let arrService = [];

        if (this.step2.services) {
            this.step2.services.forEach(service => {
                if (service.selected) {
                    arrService.push(service.value.id);
                }
            });
        }

        questData['service_id'] = arrService.join(',');


        //add broadbrand_id
        if (this.broad_plan) {
            this.broad_plan.forEach(item => {
                if (item.selected) {
                    questData['broadband_id'] = item.id;
                }
            });
        }


        //new phoneId
        if (this.step1.phoneId && this.option == 'newLine') {
            questData['phone_id'] = this.step1.phoneId;
        }

        // check type of option
        if (this.option == 'newLine') {
            questData['purchase_option'] = 'New Line';
        }
        if (this.option == 'portIn') {
            questData['purchase_option'] = 'Port In';
        }
        if (this.option == 'changePlan') {
            questData['purchase_option'] = 'Change Plan';
        }

        //new Line check phone
        if (this.step1.phone && this.option == 'newLine') {
            questData['request_number'] = this.step1.phone;
        }
        // check option has transfer
        if (this.option != 'newLine' && this.step1.typeOfNumber == 'thirdParty') {
            questData['transfer_fullname'] = this.step3.transfer.fullName;
            questData['transfer_nric'] = this.step3.transfer.NRIC;
            questData['transfer_contact_number'] = this.step3.transfer.contactNumber;
            questData['transfer_nric_img'] = this.step3.uploadScannedICTransfer.file;
        }

       
        if(this.step2.enableSupplementary1){
            if (this.step2.supplementaryPlan1.id) {
                questData['supplementary1_plan_id'] = this.step2.supplementaryPlan1.id;
            }
            if (this.step2.supplementaryDevice1.id) {
                questData['supplementary1_device_id'] = this.step2.supplementaryDevice1.id;
            }
            if (this.step2.supplementaryColor1 && this.step2.supplementaryColor1.id) {
                questData['supplementary1_device_color_id'] = this.step2.supplementaryColor1.id;
            }

            var supplementaryType1 = this.step2.supplementaryType1;
            questData['supplementary1_type'] = supplementaryType1;

            if(supplementaryType1 == "New Line"){
                if (this.step2.number1) {
                    questData['supplementary1_number'] = this.step2.number1;
                }
                if (this.step2.phoneId1) {
                    questData['supplementary1_phoneID'] = this.step2.phoneId1;
                }
            }
            if(supplementaryType1 == "Port In"){
                if (this.step2.port_in_from_1) {
                    questData['supplementary1_port_in_from'] = this.step2.port_in_from_1;
                }
                if (this.step2.network1) {
                    questData['supplementary1_network'] = this.step2.network1;
                }
                if (this.step2.number1) {
                    questData['supplementary1_number'] = this.step2.number1;
                }
            }
            if(supplementaryType1 == "Change Plan"){
                if (this.step2.change_plan_from_1) {
                    questData['supplementary1_change_plan_from'] = this.step2.change_plan_from_1;
                }
                if (this.step2.change_plan_currenTypePlan1) {
                    questData['supplementary1_current_type_plan'] = this.step2.change_plan_currenTypePlan1;
                }
                if (this.step2.number1) {
                    questData['supplementary1_number'] = this.step2.number1;
                }
            }
        }

        if(this.step2.enableSupplementary2){
            if (this.step2.supplementaryPlan2.id) {
                questData['supplementary2_plan_id'] = this.step2.supplementaryPlan2.id;
            }
            if (this.step2.supplementaryDevice2.id) {
                questData['supplementary2_device_id'] = this.step2.supplementaryDevice2.id;
            }
            if (this.step2.supplementaryColor2 && this.step2.supplementaryColor2.id) {
                questData['supplementary2_device_color_id'] = this.step2.supplementaryColor2.id;
            }

            
            var supplementaryType2 = this.step2.supplementaryType2;
            questData['supplementary2_type'] = supplementaryType2;

            if(supplementaryType2 == "New Line"){
                if (this.step2.number2) {
                    questData['supplementary2_number'] = this.step2.number2;
                }
                if (this.step2.phoneId2) {
                    questData['supplementary2_phoneID'] = this.step2.phoneId2;
                }
            }
            if(supplementaryType2 == "Port In"){
                if (this.step2.port_in_from_2) {
                    questData['supplementary2_port_in_from'] = this.step2.port_in_from_2;
                }
                if (this.step2.network2) {
                    questData['supplementary2_network'] = this.step2.network2;
                }
                if (this.step2.number2) {
                    questData['supplementary2_number'] = this.step2.number2;
                }
            }
            if(supplementaryType2 == "Change Plan"){
                if (this.step2.change_plan_from_2) {
                    questData['supplementary2_change_plan_from'] = this.step2.change_plan_from_2;
                }
                if (this.step2.change_plan_currenTypePlan2) {
                    questData['supplementary2_current_type_plan'] = this.step2.change_plan_currenTypePlan2;
                }
                if (this.step2.number2) {
                    questData['supplementary2_number'] = this.step2.number2;
                }
            }
        }

        if(this.step2.enableSupplementary3){
            if (this.step2.supplementaryPlan3.id) {
                questData['supplementary3_plan_id'] = this.step2.supplementaryPlan3.id;
            }
            if (this.step2.supplementaryDevice3.id) {
                questData['supplementary3_device_id'] = this.step2.supplementaryDevice3.id;
            }
            if (this.step2.supplementaryColor3 && this.step2.supplementaryColor3.id) {
                questData['supplementary3_device_color_id'] = this.step2.supplementaryColor3.id;
            }

            
            var supplementaryType3 = this.step2.supplementaryType3;
            questData['supplementary3_type'] = supplementaryType3;

            if(supplementaryType3 == "New Line"){
                if (this.step2.number3) {
                    questData['supplementary3_number'] = this.step2.number3;
                }
                if (this.step2.phoneId3) {
                    questData['supplementary3_phoneID'] = this.step2.phoneId3;
                }
            }
            if(supplementaryType3 == "Port In"){
                if (this.step2.port_in_from_3) {
                    questData['supplementary3_port_in_from'] = this.step2.port_in_from_3;
                }
                if (this.step2.network3) {
                    questData['supplementary3_network'] = this.step2.network3;
                }
                if (this.step2.number3) {
                    questData['supplementary3_number'] = this.step2.number3;
                }
            }
            if(supplementaryType3 == "Change Plan"){
                if (this.step2.change_plan_from_3) {
                    questData['supplementary3_change_plan_from'] = this.step2.change_plan_from_3;
                }
                if (this.step2.change_plan_currenTypePlan3) {
                    questData['supplementary3_current_type_plan'] = this.step2.change_plan_currenTypePlan3;
                }
                if (this.step2.number1) {
                    questData['supplementary3_number'] = this.step2.number3;
                }
            }
        }

        if(this.step2.enableSupplementary4){
            if (this.step2.supplementaryPlan4.id) {
                questData['supplementary4_plan_id'] = this.step2.supplementaryPlan4.id;
            }
            if (this.step2.supplementaryDevice4.id) {
                questData['supplementary4_device_id'] = this.step2.supplementaryDevice4.id;
            }
            if (this.step2.supplementaryColor && this.step2.supplementaryColor4.id) {
                questData['supplementary4_device_color_id'] = this.step2.supplementaryColor4.id;
            }

            
            var supplementaryType4 = this.step2.supplementaryType4;
            questData['supplementary4_type'] = supplementaryType4;

            if(supplementaryType4 == "New Line"){
                if (this.step2.number4) {
                    questData['supplementary4_number'] = this.step2.number4;
                }
                if (this.step2.phoneId4) {
                    questData['supplementary4_phoneID'] = this.step2.phoneId4;
                }
            }
            if(supplementaryType4 == "Port In"){
                if (this.step2.port_in_from_4) {
                    questData['supplementary4_port_in_from'] = this.step2.port_in_from_4;
                }
                if (this.step2.network4) {
                    questData['supplementary4_network'] = this.step2.network4;
                }
                if (this.step2.number4) {
                    questData['supplementary4_number'] = this.step2.number4;
                }
            }
            if(supplementaryType4 == "Change Plan"){
                if (this.step2.change_plan_from_4) {
                    questData['supplementary4_change_plan_from'] = this.step2.change_plan_from_4;
                }
                if (this.step2.change_plan_currenTypePlan4) {
                    questData['supplementary4_current_type_plan'] = this.step2.change_plan_currenTypePlan4;
                }
                if (this.step2.number4) {
                    questData['supplementary4_number'] = this.step2.number4;
                }
            }
        }

        // console.log(questData);
        this.mainCampaignServices.submitApplication(questData).subscribe(res => {
            //console.log(res);
            if (res.success) {

                if (campainAttr.enable_credit_card == 0 && campainAttr.enable_payment == 0) {

                    this.router.navigateByUrl('/thank-you');

                } else {

                    this.globalService.deleteSession('mainApplication');

                    let navigationExtras: NavigationExtras = {
                        queryParams: res.data,
                        skipLocationChange: true
                    };

                    this.router.navigate(['/', 'credit-card'], navigationExtras);
                }
                this.isSubmitLoading = false;

            } else {
                this.isSubmitLoading = false;
                this.message = {
                    display: true,
                    error: true,
                    success: false,
                    message: res.error.description
                };
            }
        }, error => {
            this.isSubmitLoading = false;
            this.message = {
                display: true,
                error: true,
                success: false,
                message: 'Submit Failed'
            };
        });
    }

    onClickRequestTAC() {

        let request = {};
        this.isSubmitLoading = true;
        this.message.dislay = false;

        this.isResendDisabled = true;

        //
        if (this.step3.yourDetail.contactNumber) {
            request['phone'] = this.step3.yourDetail.contactNumber;
        }
        if (this.step3.yourDetail.email) {
            request['email'] = this.step3.yourDetail.email;
        }
        //
        if (!request['phone'] && !request['email']) {
            this.message = {
                display: true,
                error: true,
                success: false,
                message: 'Email or Contact number invalid!'
            };
            this.isSubmitLoading = false;
            return false;
        }

        this.mainCampaignServices.requestTAC(request).subscribe(res => {
            if (res.success) {
                this.message = {
                    display: true,
                    error: false,
                    success: true,
                    message: 'request TAC successfully!'
                };

                if (request['phone']) {
                    this.message.message = 'check your SMS for TAC activation code';
                } else {
                    this.message.message = 'check your email for TAC activation code';
                }
                this.isSubmitLoading = false;

                this.resendEnabled$.next();
            } else {
                this.message = {
                    display: true,
                    error: true,
                    success: false,
                    message: res.error.description
                };
                this.isSubmitLoading = false;

                this.isResendDisabled = false;
            }
        }, error => {
            this.message = {
                display: true,
                error: true,
                success: false,
                message: 'request TAC failed!'
            };
            this.isSubmitLoading = false;

            this.isResendDisabled = false;
        });

        console.log("Show Popup Thankyou " + this.globalService.getSession('show_popup_thankyoupage'));
        console.log("Image Popup Thankyou " + this.globalService.getSession('popup_thankyoupage'));
        console.log("URL Popup Thankyou " + this.globalService.getSession('link_popup_thankyoupage'));
    }

    onClickPrev() {
        this.store.dispatch(this.mainCampaignActions.stepPrev());
    }
}
